
document.addEventListener('DOMContentLoaded', function () {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const cartOpen = urlParams.get('side-cart-open')

  if (cartOpen == 'true') {
    $('cart-drawer.drawer').addClass('active')
  }

  //If product have only single option
  $(document).on('change', '.card_wrapper_variants:not(.single-option) .card_warpper_variant input', function () {
    const cartItem = $(this).closest('.card__item')

    let option = $(this).parent().find('.card_warpper_variant-input').attr('data-option')
    let price = $(this).parent().find('.card_warpper_variant-input').attr('data-price')

    cartItem.find('.currentOption').text(option);
    cartItem.find('product-form .var_price').text(price)
    cartItem.find('button[type="submit"]').attr('aria-label', 'Add to bag ' + cartItem.find('.card_product_title').text() + ' in ' + option + ' ' + price)

    if (cartItem.find('.card_ss').length) {
      cartItem.find('.card_ss-onetime-purchase .price-current').text(price)
      cartItem.find('.card_ss-subscription-purchase .price-init').text(price)
    }

    let optionType = 'color'

    if ($(this).closest('.card_warpper_variant').hasClass('variant__size')) optionType = 'size'

    const analytics_event_data = {
      selection_type: optionType,  // e.g. "color"
      selection_value: option  // e.g. "blue"
    };

    console.log(analytics_event_data)

    Shopify.analytics.publish("cstm_item_variant_select", analytics_event_data);

    option = Convert(option.toLowerCase())

    const variantID = $(this).closest('.card_warpper_variant').find('input').attr('data-variant-id')
    cartItem.find('product-form .product-variant-id').val(variantID)

    // check if the variant has a selling plan
    const sellingPlanAllocationsSize = $(this).closest('.card_warpper_variant').find('input').attr('data-selling-plan-allocations-size');
    // if (sellingPlanAllocationsSize && sellingPlanAllocationsSize == "0") {
    //   cartItem.find('.card_ss').hide();
    // }

    if ($(this).closest('.card_warpper_variant').hasClass('variant__oos')) {
      cartItem.find('product-form').addClass('product_is_oos')
      cartItem.find('product-form .card_add2bag_text').text('Sold out')
      cartItem.find('button[type="submit"]').attr('aria-label', 'Sold out ' + cartItem.find('.card_product_title').text() + ' in ' + option);
      cartItem.find('product-form .quick-add__submit').attr('disabled', true)
    } else {
      cartItem.find('product-form').removeClass('product_is_oos')
      cartItem.find('product-form .card_add2bag_text').text('Add to bag')
      cartItem.find('product-form .quick-add__submit').removeAttr('disabled')
    }

    showSelectedVariantImage($(this))    
  })

  //If product have multiple options
  $('body').on('change', '.card_wrapper_variants.single-option .card_warpper_variant input', function () {
    const cartItem = $(this).closest('.card__item')
    const currentShade = cartItem.find('.card_wrapper_variants:not(.single-size-options) input:checked + label').attr('data-option');
    const currentSize = cartItem.find('.card_wrapper_variants.single-size-options input:checked + label').attr('data-option');
    const price = cartItem.find('button[type="submit"]').find('.var_price').text();

    cartItem.find('button[type="submit"]').attr('aria-label', 'Add to bag ' + cartItem.find('.card_product_title').text() + ' in ' + currentShade + ' and ' + currentSize + ' ' + price);

    if ($(this).closest('.card_wrapper_variants').hasClass('single-size-options')) {

      const analytics_event_data = {
        selection_type: 'size',
        selection_value: currentSize
      };

      console.log(analytics_event_data)

      Shopify.analytics.publish("cstm_item_variant_select", analytics_event_data);

      for (let elem of cartItem.find('.card_wrapper_variants:not(.single-size-options) label')) {
        let shade = $(elem).attr('data-option');
        let shade_input = $(elem).prev();
        let product_title = cartItem.find('.card_product_title').text();

        // [product title] in [product.color] in [product size].
        shade_input.attr('aria-label', product_title + ' in ' + shade + ' in ' + currentSize);

        let variantCombination = cartItem.find('.card_variants_holder .variant_item_data[data-shade="' + shade + '"][data-size="' + currentSize + '"]')

        if (variantCombination.length && variantCombination.attr('data-available') == "true") {
          $(elem).closest('.card_warpper_variant').removeClass('variant__oos');
        } else {
          shade_input.attr('aria-label', product_title + ' in ' + shade + ' in ' + currentSize + ' is sold out');
          $(elem).closest('.card_warpper_variant').addClass('variant__oos');
        }
      }
    } else {

      const analytics_event_data = {
        selection_type: 'color',
        selection_value: currentShade
      };

      console.log(analytics_event_data)

      Shopify.analytics.publish("cstm_item_variant_select", analytics_event_data);

      for (let elem of cartItem.find('.card_wrapper_variants.single-size-options label')) {
        let size = $(elem).attr('data-option')
        let size_input = $(elem).prev();
        let product_title = cartItem.find('.card_product_title').text();

        size_input.attr('aria-label', product_title + ' ' + size + ' in ' + currentShade);

        let variantCombination = cartItem.find('.card_variants_holder .variant_item_data[data-size="' + size + '"][data-shade="' + currentShade + '"]')


        if (variantCombination.length && variantCombination.attr('data-available') == "true") {
          $(elem).closest('.card_warpper_variant').removeClass('variant__oos');
        } else {
          size_input.attr('aria-label', product_title + ' ' + size + ' in ' + currentShade + ' is sold out');
          $(elem).closest('.card_warpper_variant').addClass('variant__oos');
        }
      }
    }

    const currentVariant = cartItem.find('.card_variants_holder .variant_item_data[data-shade="' + currentShade + '"][data-size="' + currentSize + '"]')

    const slectedVarID = currentVariant.attr('data-id');
    const selectedVarPrice = currentVariant.attr('data-price');


    const sku = currentVariant.attr('data-sku')
    const varPrice = currentVariant.attr('data-price')
    const title = currentVariant.attr('data-title')


    if (sku && price && title) {

      const analytics_event_data = {
        product_name: title,
        product_sku: sku,
        product_price: varPrice
      };

      console.log(analytics_event_data)

      Shopify.analytics.publish("cstm_select_item", analytics_event_data);

    }


    if (cartItem.find('.card_ss').length) {
      cartItem.find('.card_ss-onetime-purchase .price-current').text(selectedVarPrice)
      cartItem.find('.card_ss-subscription-purchase .price-init').text(selectedVarPrice)
    }

    cartItem.find('product-form .product-variant-id').val(slectedVarID)
    cartItem.find('product-form .var_price').text(selectedVarPrice)

    if ($(this).attr('name').includes('shade')) {
      showSelectedVariantImage(currentVariant)
    }
  })

  function showSelectedVariantImage(element) {
    // Update the image based on the selected variant
    const variantMedias = element.closest('.card__item').find('.card-wrapper__medias')
    variantMedias.addClass('loading')

    const selectedVariantMainImageUrl = '/cdn/shop/' + element.attr('data-variant-featured-image')
    const selectedVariantHoverImageSrc = '/cdn/shop/' + element.attr('data-variant-hover-image')

    const selectedVariantMainImageAlt = element.attr('data-variant-feature-image-alt')
    const selectedVariantHoverImageAlt = element.attr('data-variant-hover-image-alt')

    console.log(selectedVariantMainImageUrl)
    console.log(selectedVariantHoverImageSrc)

    const mainImage = buildImageElement(selectedVariantMainImageUrl, selectedVariantMainImageAlt, "card-item__image");
    const hoverImage = buildImageElement(selectedVariantHoverImageSrc, selectedVariantHoverImageAlt, "card-item__hover-image");

    Shopify.analytics.publish("cstm_gallery_change", {}); 

    mainImage.onload = function () {
      console.log('main image loaded')
      variantMedias.removeClass('loading')
      variantMedias.find('img').remove();

      variantMedias.append(mainImage);
      variantMedias.append(hoverImage);
    }
  }

  function buildImageElement(src, alt, classname) {
    const img = new Image();
    img.src = src + '?width=1080';
    img.alt = alt;
    width = 2400;
    height = 2400;
    img.srcset = src + '?width=352 352w, ' + src + '?width=832 832w';
    img.classList.add(classname, 'motion-reduce');
    return img;
  }

  $('body').on('change', '.card_wrapper_variants.single-option .card_warpper_variant input', function () {
    const cartItem = $(this).closest('.card__item');

    const currentShade = cartItem.find('.card_wrapper_variants:not(.single-size-options) input:checked + label').attr('data-option');
    const currentSize = cartItem.find('.card_wrapper_variants.single-size-options input:checked + label').attr('data-option');
    const currentVariant = cartItem.find('.card_variants_holder .variant_item_data[data-shade="' + currentShade + '"][data-size="' + currentSize + '"]')

    if (currentVariant.length && currentVariant.attr('data-available') == "true") {
      cartItem.find('product-form').removeClass('product_is_oos')
      cartItem.find('product-form .card_add2bag_text').text('Add to bag')
      cartItem.find('product-form .quick-add__submit').removeAttr('disabled')
    } else {
      cartItem.find('product-form').addClass('product_is_oos')
      cartItem.find('product-form .card_add2bag_text').text('Sold out')
      cartItem.find('button[type="submit"]').attr('aria-label', 'Sold out ' + cartItem.find('.card_product_title').text() + ' in ' + currentShade + ' in ' + currentSize);
      cartItem.find('product-form .quick-add__submit').attr('disabled', true)
    }
  })

  $('body').on('click', '.card_ss label', function () {
    console.log($(this).find('.price-current').text())
    $(this).closest('.card__item').find('.var_price').text($(this).find('.price-current').text())
  })

  //custom add 2 cart since we will need to add S&S on PLP
  // $(document).on('submit', '.card__item form', async function (e) {
  document.addEventListener('submit', function (e) {
    if (e.target.tagName !== 'FORM') return;
    if (!e.target.closest('.card__item')) return;

    const form = e.target;

    e.preventDefault();

    let isSSExist = false;
    let isSSVisible = false;
    let isPrevent = false;
    let selling_plan = false;
    const percentDiscount = 25;
    const cardItem = $(form).closest('.card__item');
    const selectedSingleOption = cardItem.find('.card_wrapper_variants input:checked + label').prev().attr('data-selling-plan-allocations-size');

    if (cardItem.find('.card-wrapper__details .card_ss').length && selectedSingleOption > 0) {
      let defaultPrice = cardItem.find('.card_ss-onetime-purchase .price-current').text().replace('$', '')

      isSSExist = true;
      if (cardItem.find('.card-wrapper__details .card_ss').is(":visible")) {
        isSSVisible = true;
        let selectedInput = cardItem.find('.card_ss input[type="radio"]:checked').val();

        if (selectedInput == 'subscription') {
          selling_plan = cardItem.find('.product-card-selected-selling-plan').attr('data-selling-plan-id');
        }
      } else {

        let ssPrice = (parseInt(defaultPrice) - ((defaultPrice / 100) * percentDiscount)).toFixed(0);

        cardItem.find('.card_ss-subscription-purchase .price-current').text('$' + ssPrice)

        cardItem.find('.card-wrapper__details .card_ss').show();
      }
    }

    if (isSSExist == true && isSSVisible == false) {
      isPrevent = true;
    }

    if (isPrevent == false) {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      formData.append('quantity', 1);


      const engravingClose = () => {
        const productId = formData.get("product-id");
        const EngravingModal = document.querySelector(`#Engraving-Modal-${productId}`);
        const engravingInputText = EngravingModal.querySelector('[data-engraving-input]');
        const engravingImageText = EngravingModal.querySelector('[data-engraving-text-container]');
        const engravingLimitText = EngravingModal.querySelector('[data-engraving-limit-container]');
        const engravingCharLimit = engravingInputText.closest('engraving-form')?.getAttribute('text-limit');

        if (EngravingModal) {
          EngravingModal.hide();

          engravingInputText.value = '';
          engravingImageText.textContent = '';
          engravingLimitText.textContent = engravingCharLimit;
          engravingInputText.placeholder = 'Enter your text';
        }
      }

      if (e.submitter.hasAttribute('data-engraving-submit')) {
        if (!formData.has("properties[_hasEngraving]")) {
          formData.delete('properties[Engraving]');
        }

        engravingClose();

      } else if (e.submitter.hasAttribute('data-engraving-cancel')) {
        formData.delete('properties[Engraving]');
        formData.delete('properties[_hasEngraving]');

        engravingClose();
      };

      if (selling_plan) {
        formData.append('selling_plan', selling_plan);
      }

      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const freeGiftItem = document.querySelector('cart-drawer-items .free-gift-item');
      const freeGiftInput = form.querySelector('input[name="properties[_free_gift]"]');

      if (freeGiftItem && freeGiftInput) {
        return;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 422) {
            if (cart) alert(response.description);
            return;
          }
          cart.renderContents(response);
        }).catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

          if (isSSExist == true) {
            cardItem.find('.card_ss-onetime-purchase input').click()
            cardItem.find('.card-wrapper__details .card_ss').hide();
            cardItem.find('.var_price').text(cardItem.find('.card_ss-onetime-purchase .price-current').text())
          }

          const itemTitle = cardItem?.find('.card_product_title')?.text().trim();
          const itemURL = cardItem?.find('.card_product_title a')?.attr('href');
          const itemID = cardItem?.find('form input[name="product-id"]')?.val();
          const itemImge = cardItem?.find('.card__variant-image:visible img')?.attr('src');
          const itemprice = cardItem?.find('.var_price')?.text();

          var klavyioItem = {
            "Name": itemTitle,
            "ProductID": itemID,
            "ImageURL": itemImge,
            "URL": itemURL,
            "Price": itemprice
          }

          var _learnq = _learnq || [];

          _learnq.push(['track', 'Added to Cart', klavyioItem]);

        });
    }

  });

  //Render swatches upon initial load
  switchOSSPLP();
})

function Convert(string) {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function switchOSSPLP() {

  if (!$('.card__item .card_wrapper_variants.single-size-options').length) return;

  for (let cartElem of $('.card__item .card_wrapper_variants.single-size-options')) {

    const cartItem = $(cartElem).closest('.card__item');
    const currentSize = cartItem.find('.card_wrapper_variants.single-size-options input:checked + label').attr('data-option');

    if (currentSize) {

      for (let elem of cartItem.find('.card_wrapper_variants:not(.single-size-options) label')) {
        let shade = $(elem).attr('data-option');
        let shade_input = $(elem).prev();
        let product_title = cartItem.find('.card_product_title').text();

        shade_input.attr('aria-label', product_title + ' in ' + shade + ' in ' + currentSize);

        let variantCombination = cartItem.find('.card_variants_holder .variant_item_data[data-shade="' + shade + '"][data-size="' + currentSize + '"]')


        if (variantCombination.length && variantCombination.attr('data-available') == "true") {
          $(elem).closest('.card_warpper_variant').removeClass('variant__oos');
        } else {
          shade_input.attr('aria-label', product_title + ' in ' + shade + ' in ' + currentSize + ' is sold out');
          $(elem).closest('.card_warpper_variant').addClass('variant__oos');
        }
      }
    }

  }
}